module.exports = __webpack_public_path__ + "img/Korean_Meal_Tofu.7589910e.jpg";